import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TopMasterKeyResult } from '../models/TopMasterKeyResult';
import { CombinationConfig } from '../configuration/keying.combination.environment.config';

@Injectable({
  providedIn: 'root',
})
export class TopMasterKeyService {
  constructor(private config: CombinationConfig, private httpClient: HttpClient) {}

  getKeysForFivePin(parity: string): Observable<Array<TopMasterKeyResult>> {
    return this.httpClient.get<Array<TopMasterKeyResult>>(
      `${this.config.getKeyingUrl()}/topmasterkey?pins=five&parity=${parity}`
    );
  }
  getKeysForSixPin(parity: string): Observable<Array<TopMasterKeyResult>> {
    return this.httpClient.get<Array<TopMasterKeyResult>>(
      `${this.config.getKeyingUrl()}/topmasterkey?pins=six&parity=${parity}`
    );
  }
}
